import { Component, Input } from '@angular/core';

import { MasterDataService } from '../../services/master-data.service';
import { ApiCallCachingService } from '../../services/api-call-caching.service';

import { DropdownBaseComponent } from './dropdown-base/dropdown-base.component';

import { LegalEntitySimpleListItem } from '../../models/master-data/legal-entity-simple-list-item.model';

import { map } from 'rxjs/operators';

@Component({
    selector: 'spv2-legal-entity-dropdown',
    templateUrl: './dropdown-base/dropdown-base.component.html',
    styleUrls: ['./dropdown-base/dropdown-base.component.scss'],
    standalone: false
})
export class LegalEntityDropdownComponent extends DropdownBaseComponent<string, LegalEntitySimpleListItem> {
  
  private _companyId : string;
  @Input() public set companyId(v : string) {
    this._companyId = v;
    if(this.value) {
      this.value = null;
      this.valueChange.emit(this.value);
    }
    this.debounceTrigger.execute(null);
  }

  get uniqueName() {
    return "legalEntities" + this._companyId;
  } 

  textField = "name";
  valueField = "id";

  enableCache = false;
  
  loadDataAutomatically = false;

  dataFunction = (filter) => this.masterDataService.getSimpleLegalEntityList(filter, this._companyId);

  constructor(private masterDataService: MasterDataService, cachingService: ApiCallCachingService) {
    super(cachingService);
  }

}
